import zhCN from "./zh-CN";
import zhHK from "./zh-HK";
import enUS from "./en-US";

export default {
  "zh-CN": zhCN,
  "en-US": enUS,
  "zh-HK": zhHK,
};
